module.exports = __webpack_public_path__ + "img/img-exercise-muscle-02.90a75a62.png";